import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "#000000",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M20 3H4a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3Zm1 15a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1ZM9 12v4a1 1 0 0 1-2 0v-4a1 1 0 0 1 2 0Zm4-2v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 2 0Zm4-2v8a1 1 0 0 1-2 0V8a1 1 0 0 1 2 0Z" }, null, -1)
  ]))]))
}
export default { render: render }